import { SponsorPlacement } from 'api';

export const CAMPAIGN_PLACEMENT_LABEL: Record<SponsorPlacement, string> = {
  headlinerApp: "headliner's app",
  publisherNetwork: 'publisher network',
  youtubePromotion: 'YouTube',
};
